import { Injectable, inject } from "@angular/core";
import { Route, Router } from "@angular/router";
import { MunicipalityTokenService } from "src/app/servicios/municipality-token/municipality-token.service";
import { ValidRoles } from "src/app/utils/directives/validateRoles/validate-roles.directive";

@Injectable({
  providedIn: "root",
})
export class HasRoleGuard  {
  private router = inject(Router);
  municipalityTokenService = inject(MunicipalityTokenService);

  /**
   * Funcion para implementar un canLoad en las rutas
   * @param route Ruta a la que se le efectua el canload
   * @returns
   */
  async canLoad(route: Route): Promise<boolean> {
    const isReady = await this.municipalityTokenService.waitUntilReady();
    if (!isReady) {
      this.router.navigateByUrl("/");
      return false;
    }

    const hasToken = this.municipalityTokenService.getToken();

    if (hasToken) {
      let modulos = this.municipalityTokenService.getModules();
      const idRolUser = this.municipalityTokenService.getUserMunicipalityRole();
      const routeModuleId = route.data?.moduleId?.toString();

      if (modulos && routeModuleId) {
        const modulosArray = modulos.split(",");
        let hasAccess = modulosArray.includes(routeModuleId);

        let isSuperAdmin = Number(idRolUser) == ValidRoles.SUPER_ADMINISTRADOR;

        // Si es el módulo Developer y el usuario es SuperAdmin se salta el permiso por Municipio
        if (routeModuleId === "8" && isSuperAdmin) {
          return true;
        }

        if (!hasAccess) {
          this.router.navigate(["/"]);
        }

        return hasAccess;
      }
    }

    this.router.navigateByUrl("/");
    return false;
  }
}
